import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import type { Produk } from '@/types'

export function useProduct(id: string) {
  const [product, setProduct] = useState<Produk | null>(null)
  const [kategoriNama, setKategoriNama] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    async function fetch() {
      const { data, error } = await supabase
        .from('produk')
        .select('id, deskripsi, harga, harga_max, tipe, stok, gambar_url, aktif, sewa_per_hari, category_id, satuan_id, master_item_id, created_at')
        .eq('id', id)
        .single()

      if (error || !data) {
        setNotFound(true)
        setLoading(false)
        return
      }

      const [{ data: master }, { data: satuan }] = await Promise.all([
        data.master_item_id
          ? supabase.from('master_item').select('nama_item, kategori_id').eq('id', data.master_item_id).single()
          : Promise.resolve({ data: null }),
        data.satuan_id
          ? supabase.from('satuan').select('nama').eq('id', data.satuan_id).single()
          : Promise.resolve({ data: null }),
      ])

      // Fetch nama kategori dari master_item.kategori_id
      if (master?.kategori_id) {
        const { data: kat } = await supabase
          .from('categories')
          .select('nama')
          .eq('id', master.kategori_id)
          .single()
        setKategoriNama(kat?.nama ?? null)
      }

      setProduct({
        ...data,
        nama: master?.nama_item || '',
        satuan: satuan?.nama || 'unit',
        harga_max: (data as any).harga_max ?? null,
        sewa_per_hari: (data as any).sewa_per_hari ?? false,
      })
      setLoading(false)
    }

    fetch()
  }, [id])

  return { product, kategoriNama, loading, notFound }
}
